export const getShareGeneratedCoverMessage = (
  voiceName: string,
  fileName: string,
) =>
  `Successfully generated AI ${voiceName} Cover [${fileName}] with AudioModify! Check out what I made:`;

export const appShareMessage =
  "Generate AI music covers with your favorite voices in seconds with AudioModify!";
